(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"));
	else if(typeof define === 'function' && define.amd)
		define(["React"], factory);
	else if(typeof exports === 'object')
		exports["ice"] = factory(require("React"));
	else
		root["ice"] = factory(root["React"]);
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__4883__) => {
return 